import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/compat/app';
import { useFirestoreQuery } from '../hooks';

import Message from './Message';
import db from '../firebase';

const Channel = ({ user = null }) => {
    
   // const query = db.collection('chats').orderBy('SendTime').limit(100);
    const messagesRef = db.collection('chats');
    const messages = useFirestoreQuery(
        messagesRef
      );

   // const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');

    const inputRef = useRef();
    

    const { uid, displayName, photoURL } = user;
    useEffect(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, [inputRef]);
    

    const handleOnSubmit = e => {
        e.preventDefault();
          // Add new message in Firestore
        db.collection('chats').add({
            Text: newMessage,
            SendTime: firebase.firestore.Timestamp.fromDate(new Date()),
            uid,
            displayName,
            photoURL, 
        });
        // Clear input field
        setNewMessage('');
        
      };
      return (
        <div className="flex flex-col h-full">
          <div className="overflow-auto h-full">
            <div className="py-4 max-w-screen-lg mx-auto">
              <ul>
                {messages
                  ?.sort((first, second) =>
                    first?.SendTime?.seconds <= second?.SendTime?.seconds ? -1 : 1
                  )
                  ?.map(message => (
                    <li key={message.id}>
                      <Message {...message} />
                    </li>
                  ))}
              </ul>
              
            </div>
          </div>
          <div className="mb-6 mx-4">
            <form onSubmit={handleOnSubmit} className="flex flex-row bg-gray-200 dark:bg-coolDark-400 rounded-md px-4 py-3 z-10 max-w-screen-lg mx-auto dark:text-white shadow-md"
            >
              <input
                
                type="text"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                placeholder="Type your message here..."
                className="flex-1 bg-transparent outline-none"
              />
              
              <button
                type="submit"
                disabled={!newMessage}
                className="uppercase font-semibold text-sm tracking-wider text-gray-500 hover:text-gray-900 dark:hover:text-white transition-colors"
              >
                  send
              </button>  
                
              
            </form>
          </div>
        </div>
      );
    };
    
    Channel.propTypes = {
      user: PropTypes.shape({
        uid: PropTypes.string,
        displayName: PropTypes.string,
        photoURL: PropTypes.string,
      }),
    };
    
    export default Channel;